import { useQueries } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { useRouter } from 'next/router';
import React, { useMemo } from 'react';

import FaqsPage from '../components/pages/faqs';
import { DETAILED_PRICES, SHIPPING_LOCATION } from '../static/cookies';
import { isGlobalUser } from '../utils/is-global-user';
import { isUKuser } from '../utils/is-uk-user';
import { isUSuser } from '../utils/is-us-user';
import getFaqs from '../utils/react-query/query-options/get-faqs';
import getFaqsSchema from '../utils/react-query/query-options/get-faqs-schema';
import getGroups from '../utils/react-query/query-options/get-groups';

const useData = () => {
  const { locale } = useRouter();
  const queries = useMemo(
    () => ({
      queries: [getFaqs({ locale, slug: '' }), getFaqsSchema({ locale })].map(
        ([key, fn]) => ({
          queryKey: key,
          queryFn: fn,
        })
      ),
    }),
    [locale]
  );

  const [{ data: faqsByGroup }, { data: faqsForSchema }] = useQueries(queries);

  return {
    faqsByGroup,
    faqsForSchema,
  };
};

export default function Faqs() {
  const data = useData();
  return (
    <main>
      <FaqsPage {...data} />
    </main>
  );
}

export const getServerSideProps: GetServerSideProps = async ({
  locale = 'en',
  req,
  res,
}) => {
  isUSuser(req, res);
  isUKuser(req, res);
  isGlobalUser(req, res);

  const { default: getGenericClient } = await import('../server/client');
  const genericClient = getGenericClient();

  await Promise.all([
    genericClient.prefetchQuery(...getFaqs({ locale, slug: '' }, req)),
    genericClient.prefetchQuery(...getFaqsSchema({ locale }, req)),
  ]);

  const { default: retrieveStateAndClear } = await import(
    '../utils/retrieve-state-and-clear'
  );

  return {
    props: {
      dehydratedState: retrieveStateAndClear(genericClient),
      shippingLocation: parseInt(req.cookies[SHIPPING_LOCATION], 10),
      detailPrices: req.cookies[DETAILED_PRICES] || null,
    },
  };
};
